import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  return <section className="py-24 bg-brand-black relative z-10 border-t border-white/5" data-id="element-474">
      <div className="max-w-7xl mx-auto px-6" data-id="element-475">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-476">
          <h3 className="font-display text-2xl md:text-3xl text-white tracking-tight max-w-3xl mx-auto leading-tight" data-id="element-477">
            "AI is only useful when it understands the real logic of the
            industry it operates in."
          </h3>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 border-t border-white/5 pt-12" data-id="element-478">
          {['Designed for complex operations', 'Secure by architecture', 'Human override built in', 'Integrates with existing systems'].map((phrase, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="text-center" data-id="element-479">
              <p className="text-sm font-medium text-gray-400 uppercase tracking-wider" data-id="element-480">
                {phrase}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}